export default function () {
  const planId = this.$route.params.id

  this.filters.plan = `/plans/${planId}`
  this.loadReport()
}
